<div class="fw-bold bg-white p-3 rounded-5 mb-3 shadow">
  <!-- Primera fila -->
  <div class="d-flex justify-content-between">
    <div>
      <label for="information" class="labelInformation" disabled>{{
        information
        }}</label>
    </div>
    <div class="col btn-back text-end">
      <button class="btn btn-secondary" (click)="goBack()">Back</button>
    </div>
  </div>

  <!-- Segunda fila -->
  <div>
    <app-customer-form (handleUserLoaded)="onUserLoaded($event)"></app-customer-form>
  </div>
</div>

<!-- <div class="bg-white p-3 rounded-5 mb-3 shadow" *ngIf="customerSummary && customerSummary.listPlans.length > 0"></div> -->
<div class="bg-white p-3 rounded-5 mb-3 shadow">


  <div class="row mt-3">
    <div class="col-9">
      <div class="mb-3 d-flex justify-content-between">
        <label for="listPlans" class="title-list">List of Plans</label>
      </div>
    </div>
    <div class="col-3 d-flex justify-content-end gap-2">
      <span>
        <button class="btn btn-info" (click)="navigateToCustomerUsers()" appTooltip="Assign User">
          <i class="bi bi-person-plus"></i>
        </button>
      </span>
      <span>
        <button *ngIf="permissionsService.nameRoleLogged == 'Customer'" class="btn btn-light" data-bs-toggle="modal"
          data-bs-target="#configurationsModalCustomer" appTooltip="Alerts">
          <i class="bi bi-gear" style="color: #495057"></i>
        </button>
      </span>

      <!-- <div class="float-end">
        <input [(ngModel)]="viewArchivedPlans" type="checkbox" class="btn-check" name="options-outlined"
          id="viewArchivedPlans" autocomplete="off" (change)="onCheckboxChange($event)">
        <label class="btn btn-outline-success" for="viewArchivedPlans" [appTooltip]="'View archived Plans'"><i
            class="bi bi-archive"></i></label>
      </div> -->
    </div>



  </div>

  <app-table-control [columns]="plansColumns" [data]="listOfPlans" [pageSize]="5" (actionClick)="onPlansAction($event)"
    [actionButtons]="plansActionButtons" [showActions]="true"></app-table-control>

</div>


<div class="fw-bold bg-white p-3 rounded-5 mb-3 shadow" *ngIf="unassingnedDevices.length > 0">
  <div class="row">
    <h4 for="listPlans"><strong>Device(s) Not Yet Assigned to a Plan</strong></h4>
  </div>
  <div class="row">
    <app-table-control [columns]="unassingnedDevicesColumns" [data]="unassingnedDevices" [pageSize]="5"
      (actionClick)="onAction($event)" [actionButtons]="actionButtons" [showActions]="false"></app-table-control>
  </div>
</div>

<!-- Modal Configurations -->
<div class="modal fade" id="configurationsModalCustomer" tabindex="-1" aria-labelledby="configurationsModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" style="margin-top: 0vh">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="configurationsModalLabel" style="font-weight: bold">
          Alerts
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeModal()"></button>
      </div>
      <!-- Hacer el contenido del modal desplazable -->
      <div class="modal-body" style="max-height: 60vh; overflow-y: auto;">
        <!-- Iterar sobre los planes del cliente -->
        <div *ngFor="let plan of this.listOfPlans; let i = index" class="mb-3">
          <div class="card">
            <div class="card-header text-left" style="font-weight: bold">
              <strong>{{ plan.planName }}</strong>
            </div>
            <div class="card-body">
              <!-- Título del plan y control de rango -->
              <label [for]="'rangeControl' + i" class="form-label">
                Set the consumption alert threshold percentage:
              </label>
              <input type="range" class="form-range" [id]="'rangeControl' + i" min="50" max="100"
                [(ngModel)]="plan.alertSendPercentage" (input)="updateValue($event)" />
              <!-- Mostrar el valor seleccionado dinámicamente -->
              <p class="mt-2">
                Alert threshold for <strong>{{ plan.planName }}</strong> set to: {{ plan.alertSendPercentage }}%
              </p>
              
         
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()">
          Close
        </button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updatePlansPercentage()">
          Save changes
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Modal Confirmation Data-->
<div class="modal fade" id="confirmationData" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel" style="font-weight: bold">
          Report Filters
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="exportToExcelListPlanDevicesAnnual(false)"></button>
      </div>
      <div class="modal-body">
        <div class="fw-bold bg-white p-3 rounded-5 mb-5">
          <!-- Primera fila -->
          <div class="row mt-3">
            <div class="col">
              <label for="information">{{
                informationFilters
                }}</label>
            </div>
          </div>

          <!-- Segunda fila -->
          <div class="row mt-3">
            <div class="col">
              <label for="fromDate">From Date</label>
              <input type="date" class="form-control input-label" (input)="checkFieldsFilter()" [(ngModel)]="fromDate"
                id="fromDate" name="fromDate" />
            </div>

            <div class="col">
              <label for="toDate">To Date</label>
              <input type="date" class="form-control input-label" (input)="checkFieldsFilter()" [(ngModel)]="toDate"
                [min]="minDate()" id="toDate" name="toDate" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
          (click)="exportToExcelListPlanDevicesAnnual(false)">
          Close
        </button>
        <!-- <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="updatePlan(true)"
            [disabled]="!fieldsCompleted">
            Yes, Update
          </button> -->
        <button type="button" class="btn btn-primary" (click)="exportToExcelListPlanDevicesAnnual(true)"
          [disabled]="!fieldsCompletedFilter">
          Generate Report
        </button>
      </div>
    </div>
  </div>
</div>

<!-- <app-activate-un-assigned-device-modal [userPlans]="customerSummary.listPlans"
  [iccid]="selectedIccid"></app-activate-un-assigned-device-modal> -->